<div class="h-screen flex justify-center items-center p-5 ">
  <div class=" border-spacing-9 border-2  min-h-[800px] min-w-[400px]   absolute ">

    @for (component of components(); track component){
      @switch (component.type){
        @case (TypeComponent.TEXT){
          <lib-text [component]="component"></lib-text>
        }
        @case (TypeComponent.IMAGE_BUTTON){
          <lib-button-image [component]="component"></lib-button-image>
        }
        @case (TypeComponent.CARROUSEL){
          <lib-carousel [component]="component"></lib-carousel>
        }
        @case (TypeComponent.IMAGE){
          <lib-image [component]="component"></lib-image>
        }
        @case (TypeComponent.BUTTON){
          <lib-app-button [component]="component"></lib-app-button>
        }
        @case (TypeComponent.VIDEO){
          <lib-video [component]="component"></lib-video>
        }
      }
    }
  </div>

</div>



